import api from '@/libs/axios'

export default {
  /**
   * Obtém token de autenticação do SINIR
   * @param {string} cpfCnpj - CPF/CNPJ do gerador (apenas números)
   * @param {string} senha - Senha do SINIR
   * @param {number} unidade - Código da unidade no SINIR
   * @returns {Promise<{token: string}>}
   */
  getToken: (cpfCnpj, senha, unidade) => api.post('/system/sinir/token', { cpfCnpj, senha, unidade }),

  /**
   * Gera manifesto (MTR) no SINIR
   * @param {Object} data - Dados do manifesto
   * @param {string} data.token - Token de autenticação
   * @param {number} data.operationId - ID da operação no Verdesys
   * @param {string} data.nomeResponsavel - Nome do responsável
   * @param {string} [data.nomeMotorista] - Nome do motorista
   * @param {string} [data.placaVeiculo] - Placa do veículo
   * @param {number} [data.dataExpedicao] - Data de expedição (timestamp em ms)
   * @param {string} [data.observacoes] - Observações
   * @returns {Promise<{success: boolean, mtrNumber: string, codigoGerado: number, message: string}>}
   */
  gerarManifesto: data => api.post('/system/sinir/manifesto', data),

  /**
   * Consulta status de manifesto no SINIR
   * @param {string} token - Token de autenticação
   * @param {string} manNumero - Número do manifesto
   * @returns {Promise<Object>}
   */
  consultarManifesto: (token, manNumero) => api.post(`/system/sinir/manifesto/${manNumero}/consultar`, { token }),

  /**
   * Busca credenciais SINIR salvas no perfil do usuário
   * @returns {Promise<{sinir_cpf_cnpj: string, sinir_unidade: number, sinir_nome_responsavel: string, has_senha: boolean}>}
   */
  getSinirCredentials: () => api.get('/system/users/me/sinir'),

  /**
   * Busca credenciais SINIR com senha descriptografada (uso interno para gerar MTR)
   * @returns {Promise<{sinir_cpf_cnpj: string, sinir_senha: string, sinir_unidade: number, sinir_nome_responsavel: string}>}
   */
  getSinirCredentialsWithPassword: () => api.get('/system/users/me/sinir/full'),

  /**
   * Salva credenciais SINIR no perfil do usuário
   * @param {Object} data - Dados das credenciais
   * @returns {Promise<Object>}
   */
  saveSinirCredentials: data => api.patch('/system/users/me/sinir', data),
}
